export default __webpack_public_path__ + "static/media/QF_logoVrt.a43f0bf0.png";